module.exports = __webpack_public_path__ + "fonts/Nexa_Bold.f98d31c8.woff2";